"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getTherapyStore = (store) => store.therapy;
const getTherapyNote = (store) => getTherapyStore(store).therapyNote;
exports.default = {
    getTherapyNote,
};
